export default __webpack_public_path__ + "static/img5-7bace8dae53afb7542fed58b3a0556b2.png";